import * as React from 'react';
import styled from 'styled-components';

import { baseFormStyles } from '../../../util/styles';
import colors from '../../colors';
import DIMarketing from '../../Shared/DIMarketing';
import BaseSendForm, { BaseProps, BaseState, initialState } from '../BaseSendForm';

export default class SendForm extends BaseSendForm<BaseProps, BaseState> {
    state = initialState;

    public render() {
        const { message } = this.state;
        const { disabled } = this.props;
        return (
            <span>
                <Wrapper className="conversations-composer">
                    <TextArea
                        className="conversations-composer-input"
                        innerRef={c => (this.inputRef = c)}
                        onChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        value={message}
                    />
                    <Button
                        className="conversations-composer-send"
                        onClick={this.handleButtonClick}
                        disabled={disabled}
                    >Send
                    </Button>
                </Wrapper>
                <MarketingWrapper className="conversations-branding">
                    <DIMarketing className="conversations-branding-name" />
                </MarketingWrapper>
            </span>
        );
    }
}

const Wrapper = styled.div`padding-bottom: 7px;`;

const TextArea = styled.textarea`
    ${baseFormStyles} box-sizing: border-box;
    border-radius: 3px;
    height: 64px;
    resize: none;
`;

export const Button = styled.button`
    background-color: ${props => props.theme.accentColor1};
    width: 100%;
    color: ${colors.white};
    &:hover,
    &:focus {
        color: ${colors.white};
    }
    &:disabled {
        background-color: ${colors.mediumLightGray};
        color: ${colors.mediumDarkGray};
        cursor: not-allowed;
    }
    font-size: 14px;
    font-weight: 400;
    margin: 10px 0 0 0;
    padding: 10px;
    border: 0;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.1s ease-in;
    height: inherit;
    text-transform: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    &:focus {
        outline: none;
    }
`;

const MarketingWrapper = styled.div`margin-bottom: 7px;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Sidebar/SendForm.tsx